var a={mobileStepper:1e3,fab:1050,speedDial:1050,appBar:1100,drawer:1200,modal:1300,snackbar:1400,tooltip:1500};export{a as default};
//# sourceMappingURL=zIndex.js.map
